module.exports = __webpack_public_path__ + "media/images/weather/250_day-cb1651e9352b7b0348d095869133a462.png";